import { render, staticRenderFns } from "./UnitListView.vue?vue&type=template&id=7854742e&"
import script from "./UnitListView.vue?vue&type=script&lang=js&"
export * from "./UnitListView.vue?vue&type=script&lang=js&"
import style0 from "./UnitListView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports